import React, { useEffect, useState } from 'react';
import { AlertTriangle, Info, CheckCircle, XCircle, Wrench } from 'lucide-react';
import axios from 'axios';

const AnnouncementBanner = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  const API_URL = process.env.REACT_APP_BACKEND_URL || '';

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setLoading(false);
        return;
      }

      const response = await axios.get(`${API_URL}/api/v2/announcements/active`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data?.announcements) {
        setAnnouncements(response.data.announcements);
      }
    } catch (error) {
      // Silently fail
      console.error('Failed to fetch announcements:', error);
    } finally {
      setLoading(false);
    }
  };

  const getTypeConfig = (type) => {
    switch (type) {
      case 'warning':
        return { 
          icon: AlertTriangle, 
          bgColor: '#fef3c7', // amber-100
          borderColor: '#f59e0b', // amber-500
          textColor: '#92400e', // amber-800
          iconColor: '#d97706' // amber-600
        };
      case 'maintenance':
        return { 
          icon: Wrench, 
          bgColor: '#f5d0fe', // fuchsia-200
          borderColor: '#d946ef', // fuchsia-500
          textColor: '#86198f', // fuchsia-800
          iconColor: '#c026d3' // fuchsia-600
        };
      case 'success':
        return { 
          icon: CheckCircle, 
          bgColor: '#d1fae5', // emerald-100
          borderColor: '#10b981', // emerald-500
          textColor: '#065f46', // emerald-800
          iconColor: '#059669' // emerald-600
        };
      case 'error':
        return { 
          icon: XCircle, 
          bgColor: '#fee2e2', // red-100
          borderColor: '#ef4444', // red-500
          textColor: '#991b1b', // red-800
          iconColor: '#dc2626' // red-600
        };
      default: // info
        return { 
          icon: Info, 
          bgColor: '#dbeafe', // blue-100
          borderColor: '#3b82f6', // blue-500
          textColor: '#1e40af', // blue-800
          iconColor: '#2563eb' // blue-600
        };
    }
  };

  if (loading || announcements.length === 0) return null;

  return (
    <div className="space-y-0">
      {announcements.map((announcement) => {
        const config = getTypeConfig(announcement.type);
        const Icon = config.icon;
        
        return (
          <div 
            key={announcement.id}
            style={{ 
              backgroundColor: config.bgColor, 
              borderLeftWidth: '4px',
              borderLeftColor: config.borderColor 
            }}
            className="px-4 py-3 shadow-sm"
          >
            <div className="max-w-7xl mx-auto">
              <div className="flex items-start gap-3">
                <Icon style={{ color: config.iconColor }} className="h-6 w-6 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <p style={{ color: config.textColor }} className="text-base font-bold">
                    {announcement.type === 'maintenance' ? '🔧 ' : 
                     announcement.type === 'warning' ? '⚠️ ' : 
                     announcement.type === 'success' ? '✅ ' : 
                     announcement.type === 'error' ? '❌ ' : 'ℹ️ '}
                    {announcement.title}
                  </p>
                  <p style={{ color: config.textColor }} className="text-sm mt-1 opacity-90">
                    {announcement.message}
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AnnouncementBanner;
